import { SubgenreMap } from '../../../../../features/account'
import { TrackedGame } from '../../../../../features/live-events/types/TrackedGame'
import { InternalOrganizationPermissions, InternalPermissionType } from '../../../../types/InternalPermission'
import { InternalReport, InternalReportVisibility } from '../../../reports/types/InternalReport'

export const accessTabs = ['reports', 'live-event-games'] as const
export type AccessTab = (typeof accessTabs)[number]

export const accessTabLabelKeys: Record<AccessTab, string> = {
  reports: 'internal-csm:organization_access_tab_reports',
  'live-event-games': 'internal-csm:organization_access_tab_live_event_games',
}

export const reportVisibilityLabelKeys: Record<InternalReportVisibility, string> = {
  [InternalReportVisibility.Public]: 'internal-csm:organization_access_visibility_public',
  [InternalReportVisibility.Private]: 'internal-csm:organization_access_visibility_private',
  [InternalReportVisibility.Teaser]: 'internal-csm:organization_access_visibility_teaser',
}

export const getGrantedIds = (permissions: InternalOrganizationPermissions | undefined, type: InternalPermissionType) =>
  new Set((permissions?.permissions ?? []).filter((permission) => permission.type === type).flatMap(({ itemIds }) => itemIds))

/** The ids among `itemIds` that the stored permissions don't grant. */
export const getMissingGrants = (stored: InternalOrganizationPermissions | undefined, type: InternalPermissionType, itemIds: string[]) => {
  const granted = getGrantedIds(stored, type)
  return itemIds.filter((itemId) => !granted.has(itemId))
}

export const getReportTitle = (report: InternalReport) => report.title.en ?? ''

export const filterReports = (reports: InternalReport[], search: string) => {
  const term = search.trim().toLowerCase()
  return term ? reports.filter((report) => getReportTitle(report).toLowerCase().includes(term)) : reports
}

/** Legacy's filter: any selected subgenre limits the games to those subgenres, then the name has to contain the search. */
export const filterTrackedGames = (trackedGames: TrackedGame[], subgenres: SubgenreMap, search: string) => {
  const anySubgenre = Object.values(subgenres).some(Boolean)
  const term = search.trim().toLowerCase()
  return trackedGames.filter(
    ({ game }) => (!anySubgenre || !!subgenres[game.conventionalSubgenreId]) && (!term || (game.name ?? '').toLowerCase().includes(term))
  )
}

/** `Game` replaces the subgenre with its translation, which is empty until the taxonomy translations are loaded. */
export const getTrackedGameSubgenre = ({ game }: TrackedGame) => game.conventionalSubgenre || game.data?.conventionalSubgenre || ''
